import React, { useCallback, useEffect, useState } from "react";
import { AlertCircle, AlertTriangle, XCircle } from "lucide-react";
import api from "@/lib/api";

// V1.33-C · Badge de contadores globales de estado documental.
// Se instala en la barra superior del Dashboard. Polling ligero cada 60s.
// - 🔴 Pendientes de validar
// - 🟡 Rechazados sin resubir
// - ⚠️ Sin reconciliar en OneDrive
// El click emite `onNavigate("bitacora")` o navega a un modal, gestionado
// por el padre (opcional).

const POLL_INTERVAL_MS = 60_000;

function Pill({ tone, count, label, icon: Icon, testid, onClick }) {
  const tones = {
    red:   "bg-red-50    text-red-700    border-red-200 hover:bg-red-100",
    amber: "bg-amber-50  text-amber-700  border-amber-200 hover:bg-amber-100",
    orange:"bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100",
    neutral:"bg-neutral-50 text-neutral-500 border-neutral-200 hover:bg-neutral-100",
  };
  const cls = count > 0 ? tones[tone] : tones.neutral;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      title={label}
      className={
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 " +
        "text-xs font-semibold transition-colors " + cls
      }
    >
      <Icon className="h-3.5 w-3.5" />
      <span className="tabular-nums">{count}</span>
      <span className="hidden md:inline text-[10px] uppercase tracking-wider opacity-80">
        {label}
      </span>
    </button>
  );
}

export default function CorporateAlertsBadge({ onNavigate }) {
  const [counters, setCounters] = useState({ pending: 0, rejected: 0, orphans: 0 });
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/corporate/documents/counters");
      setCounters({
        pending: data.pending || 0,
        rejected: data.rejected || 0,
        orphans: data.orphans || 0,
      });
      setLoaded(true);
    } catch {
      // silencioso — no interrumpe navegación
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(t);
  }, [load]);

  if (!loaded) return null;
  const total = counters.pending + counters.rejected + counters.orphans;
  if (total === 0) return null;  // no muestra pastilla si todo OK

  return (
    <div
      className="flex items-center gap-1.5"
      data-testid="corporate-alerts-badge"
    >
      <Pill
        tone="red" icon={AlertCircle}
        count={counters.pending} label="Pdt. validar"
        testid="alerts-pending"
        onClick={() => onNavigate?.("alumnos")}
      />
      <Pill
        tone="amber" icon={XCircle}
        count={counters.rejected} label="Rechazados"
        testid="alerts-rejected"
        onClick={() => onNavigate?.("alumnos")}
      />
      <Pill
        tone="orange" icon={AlertTriangle}
        count={counters.orphans} label="Sin reconciliar"
        testid="alerts-orphans"
        onClick={() => onNavigate?.("documentos")}
      />
    </div>
  );
}
